import { createSlice } from "@reduxjs/toolkit";

const loadStateFromLocalStorage = () => {
    try {
        const serializedState = localStorage.getItem('selectedProducts');
        return serializedState ? JSON.parse(serializedState) : [];
    } catch (error) {
        console.error("Error loading state from localStorage:", error);
        return [];
    }
};

const initialState = {
    selectedProducts: loadStateFromLocalStorage(),
};

const productSlice = createSlice({
    name: "product",
    initialState,
    reducers: {
        addProducts: (state, action) => {
            const newProduct = action.payload;

            const existingProduct = state.selectedProducts.find(
                product => product.barCode === newProduct.barCode
            );
            if (existingProduct) {
            } else {
                state.selectedProducts.push({ ...newProduct });
            }

            localStorage.setItem('selectedProducts', JSON.stringify(state.selectedProducts));
        },
        removeProduct: (state, action) => {
            state.selectedProducts = state.selectedProducts.filter(
                product => product.barCode !== action.payload.barCode
            );

            localStorage.setItem('selectedProducts', JSON.stringify(state.selectedProducts));
        },
        setProductsOnInit: (state, action) => {
            const { products } = action.payload;
            state.selectedProducts = products;

            localStorage.setItem('selectedProducts', JSON.stringify(products));
        },
        resetState: (state) => {
            state.selectedProducts = [];
            localStorage.setItem('selectedProducts', JSON.stringify([]));
        },
    },
});

export const { addProducts, removeProduct, resetState, setProductsOnInit } = productSlice.actions;
export default productSlice.reducer;
